import DatabaseActions from "./Database.actions";

export interface StateDatabase {
	sample: string;
	// isLoading: boolean;
	// weatherData: WeatherReduxType[] | null;
}

export const defaultState: StateDatabase = {
	sample: "sample",
	// isLoading: false,
	// weatherData: null,
};

// type DatabaseActionTypes = ReturnType<typeof DatabaseActions.SET_IS_LOADING.action>;
type DatabaseActionTypes = any;

export default (
	state: StateDatabase = defaultState,
	action: DatabaseActionTypes,
): StateDatabase => {
	switch (action.type) {
		// case WeatherDataActions.SET_IS_LOADING.ACTION:
		// 	return {
		// 		...state,
		// 		isLoading: action.payload,
		// 	};

		default:
			return state;
	}
};
